export default __webpack_public_path__ + "static/media/signatureIcon.2c2e488e.svg";